import snapshotService from "@/services/mrfiktiv/services/snapshotService";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";
import { Snapshot } from "@/models/snapshot.entity";

export class SnapshotFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.SNAPSHOT;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.SNAPSHOT, async () => {
      const doc = await snapshotService.getDocumentBySharedAccessToken(partnerId, refId, sct);

      const mapped = new Snapshot(doc);

      return mapped;
    });
  }
}
